import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities } from 'redux-modules/entity'

import api from 'api'

const UPDATE_REQUEST = 'realhub/digitalTemplatePage/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/digitalTemplatePage/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/digitalTemplatePage/UPDATE_FAILURE'

const DELETE_REQUEST = 'realhub/moduleName/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/moduleName/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/moduleName/DELETE_FAILURE'

const SELECT_PAGE = 'realhub/digitalTemplatePage/SELECT_PAGE'

// Initial State
const initialState = {
  updating: false,
  selectedId: null,
  deleting: false,
  errors: [],
}

// Actions
export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function selectPage(pageId){
  return (dispatch) => {
    dispatch({
      type: SELECT_PAGE,
      selectedId: pageId,
    })
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function updateDigitalTemplatePage(digitalTemplatePage, options, callback){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      digital_template_page: digitalTemplatePage,
    }),
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api(`/admin/digital_template_pages/${digitalTemplatePage.id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.DIGITAL_TEMPLATE_PAGE)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        if (callback) callback(json)

        return json
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

export function importDigitalTemplatePageLayout(digitalTemplatePage, options, callback){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      digital_template_page: digitalTemplatePage,
    }),
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const url = `/admin/digital_template_pages/${digitalTemplatePage.id}/import_layout_data.json`
    const promise = api(url, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.DIGITAL_TEMPLATE_PAGE)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        if (callback) callback(json)

        return json
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

export function deleteDigitalTemplateItemAttachments(digitalTemplatePage, digitalTemplateItemIds){
  const config = {
    method: 'DELETE',
    body: JSON.stringify({
      digital_template_item_ids: digitalTemplateItemIds,
    }),
  }

  return (dispatch) => {
    dispatch(deleteRequest())

    const promise = api(`/admin/digital_templates/${digitalTemplatePage.id}/destroy_item_attachments.json`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        return json
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(deleteFailure(errors))
      })
    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors: action.errors,
      }
    case SELECT_PAGE:
      return {
        ...state,
        selectedId: action.selectedId,
      }
    case DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
      }
    case DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        errors: [],
      }
    case DELETE_FAILURE:
      return {
        ...state,
        deleting: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
